// ------------------------------------
// Constants
// ------------------------------------
export const HEALTH_CHECK_QUESTIONNAIRE = 'healthCheck.HEALTH_CHECK_QUESTIONNAIRE';
export const CREATE_HEALTH_CHECK_QUESTIONNAIRE_TEMPLATE_QUESTION =
  'CREATE_HEALTH_CHECK_QUESTIONNAIRE_TEMPLATE_QUESTION';
export const CREATE_HEALTH_CHECK_QUESTIONNAIRE_TEMPLATE_ERROR = 'CREATE_HEALTH_CHECK_QUESTIONNAIRE_TEMPLATE_ERROR';
export const CREATE_HEALTH_CHECK_QUESTIONNAIRE_TEMPLATE_QUESTION_ERROR =
  'CREATE_HEALTH_CHECK_QUESTIONNAIRE_TEMPLATE_QUESTION_ERROR';
